const Form027EN = {
    stepName: {
        statement: "Important Notes",
        personalData: "Personal Particulars",
        takeOfficeSchoolInfo: "Serving School",
        teachingExperience: "Teaching Experience",
        learnDetails: "Education",
        auxiliaryInformation: "Supporting Information",
        signature: "Other Supporting Documents",
        declaration: "Declaration",
        submitRequired: "Hard Copy Submission Required ",
        confirmation: "Confirmation",
    },
    noteslable: [
        { step: "(a)" },
        { step: "(b)" },
        { step: "(c)" },
        { step: "(d)" },
        { step: "(e)" },
        { step: "(f)" },
        { step: "(g)" },
        { step: "(h)" },
    ],
    notesList: {
        noteA: "Read the information on the EDB website <a href='https://www.edb.gov.hk/scholarship_teacher' target='_blank'>(https://www.edb.gov.hk/scholarship_teacher)</a> and the relevant Circular Memorandum (EDBCM No. {{edbcmNo}}) carefully before completing this Form.",
        noteB: "During the application, applicants are required to upload the following pieces of information. Applicants are advised to prepare the files in electronic copies before completing this Form. Please retain the original copies for verification at a later stage.",
        noteBlist: [
            {
                text: "Contribution outside the School",
            },
            {
                text: "Contribution to the school with the signature of the Principal(s)",
            },
            {
                text: "Personal statement [Questions (i), (ii) and (iii) –action plan with the signature of the Principal(s)]",
            },
            { text: "The Hong Kong Identity Card of the applicant" },
            {
                text: "Certificate for Registration as a Teacher of the applicant",
            },
            {
                text: "Offer letter for the master’s degree programme from the institution",
            },
        ],
        noteC: "The Recommendation Form should be completed by the Principal of the applicant’s serving school. The Principal should return the completed Form by post or in person to the EDB separately by the deadline of application.",
        noteD: "Complete all relevant parts in the Form accurately.",
        noteE: "Provision of all the personal data requested in this Form is obligatory (except those items clearly marked as optional).  Application may not be processed if applicants fail to provide all information as required.  Personal data on an unsuccessful applicant will normally be destroyed 12 months after the announcement of selection results.  Any misrepresentation or concealment of fact will lead to disqualification of application.",
        noteF: "The application period is from {{applyStart}} to {{applyEnd}}.  Please submit the Application Form, together with all supporting documents before the deadline via electronic submission.  Late applications will not be accepted.",
        noteG: "An on-line application number will be generated and an acknowledgement email will be sent to the applicant upon receipt of the Application Form. Please quote this number in all future correspondence.",
        noteH: "For enquiries, please send an email to {{email}} or contact {{contactPerson}} (Tel. {{telphone}}) of the Professional Development and Training Division, Education Bureau.",
    },
    label1: {
        header: {
            headerOne: "I.Statement",
        },
        declarList: {
            tips1: "I declare that all the information provided in this Form is accurate and true. I understand that if I willfully give any false information or withhold any material information in this Application Form, or fail to notify the office concerned of any subsequent change of information provided, it will render me liable to disqualification for selection for the Scholarship for Teachers (Pursuit of Master’s Degree Programmes) ({{pursuedDate}}). If the Scholarship for Teachers has already been awarded to me, I may be required to reimburse the scholarship monies received. I understand that my application should be supported by relevant documents/evidence. If I fail to do so, my application may not be processed.",
            tips2: "Besides, I declare that:",
            tips3: "I am not concurrently receiving and will not receive any other scholarship awarded by the HKSAR Government for the said programme(s) mentioned in Step 5(II);",
            tips4: "I have not been awarded the Scholarship for Teachers (Pursuit of Master’s Degree Programmes) before; and",
            tips5: "I have not received any reprimand letters, warning letters or advisory letters issued by the Education Bureau and / or schools, and have not been convicted of a criminal offence in Hong Kong or elsewhere previously.",
            tips6: "I consent to the HKSAR Government making any necessary enquiries as required in matters relating to the Scholarship for Teachers and for the verification of the information given in my application. ",
        },
        statement:
            "I have read, understand and agree to the above terms and conditions",
        termWords: "I have read and agree to these terms and conditions.",
    },

    label: {
        header: {
            headerOne: "I.Personal Particulars",
        },
        whetherInfo: {
            yes: "Yes",
            no: "No ",
        },
        sex: {
            M: "Male",
            F: "Female",
        },
        englishName: "Name in English (Surname)",
        englishNameTwo: "Name in English (Other Names)",
        surname: "Surname",
        OtherNames: "Other Names",
        chineseName: "Name in Chinese",
        dateOfBirth: "Date of Birth",
        gender: "Sex",
        whether:
            "Are you a permanent resident of the Hong Kong Special Administrative Region?",
        IDNumber: "Hong Kong Identity Card No",
        teacherNumber: "Teacher Registration No",
        address: "Correspondence Address",
        phone: "Daytime Contact Telephone No",
        homeTelephone: "Residential Telephone No",
        email: "Email Address",
        tips: "(optional)",
    },
    label2: {
        header: {
            headerOne: "I.Serving School",
        },
        schoolNameOfEn: "School Name in English",
        schoolNameOfSc: "School Name in Chinese",
        schoolFaxNo: "School Fax No",
        schoolTel: "School Telephone No",
        schoolAddress: "School Address",
        principalName: "Name of Principal",
        rankPostTitle:
            "Applicant’s Rank (e.g.GM) and Post (e.g. Career Master)",
        rank: "Rank",
        post: "Post",
    },
    label3: {
        header: {
            headerOne:
                "I.Teaching experience information (in chronological order)",
        },
        schoolName: "Name of School",
        startDate: "Start Date (Month/Year)",
        endDate: "End Date (Month/Year)",
        // rankAndPost: "Rank (e.g.GM) and Post (e.g. Career Master)",
        job: "Job Duties",
    },
    label4: {
        SpecialisationInfo: {
            specialEducationalNeeds: "Special Educational Needs",
            giftedEducation: "Gifted Education",
            inclusiveEducation: "Inclusive Education",
            chineseCulture: "Chinese Culture",
            chineseHistoryAndHistory: "Chinese History and History",
            educationalLeadership: "Educational Leadership",
            careerGuidance: "Career Guidance",
            counselling: "Counselling",
            lifeEducation: "Life Education",
            informationTechnologyInEducation:
                " Information Technology in Education",
            chineseLanguageEducation: "Chinese Language Education",
            englishLanguageEducation: "English Language Education",
            parentEducationAndHomeSchoolCoOperation:
                "Parent Education & Home-schoolCo-operation",
            STEMEducation: "STEM Education STEM",
            valuesEducation: "Values Education",
        },
        header: {
            headerOne: "I.Study programmes attended",
            headerTwe:
                "II.Study programme to be pursued in the {{declarDate}} school year (Only applicants who will pursue year one study in the relevant study programmes starting from the {{declarDate}} school year are eligible to apply for the Scholarship.) ",
        },
        nameOfInstitution: "Name of Institution",
        programmeTitle: "Programme Title",
        specialisation: "Specialisation",
        startDate: "Start Date (Month/Year)",
        endDate: "End Date (Month/Year)",
        qualification: "Programme Title and Qualification Obtained",
        job: "Job Duties",
        awardApplyDate: "Start Date (Month/Year)",
    },

    label5: {
        header: {
            headerOne: "(I) Contribution to the school",
            headerTwe: "(II) Contribution outside the school",
        },
        schoolYear: "School Year",
        nameOfItems: "Name of Items",
        Details: "Details",
        remark: "Provide your contribution to the school in the past three years(up to three projects per year)",
    },
    label6: {
        header: {
            headerOne:
                "(II) Upload Contribution to the School with the Signature of the Principal(s)",
            headerTwe:
                "(III) Upload Personal Statement [Question (i), (ii) and (iii) –action plan with the signature of the Principal(s)]",
            // headerThree:
            //     "Upload Duly completed Recommendation Form with the signature of the Principal and School Chop",
            headerFour: "Upload The Hong Kong Identity Card of the Applicant",
            headerFive:
                "Upload Certificate for Registration as a Teacher of the Applicant",
            headerSix:
                "Upload Offer Letter for the Master's Degree Programme from the Institution",
            headerSeven: "(I) Upload Contribution outside the School",
        },
        proofDocText: "File only accepted：.pdf, .png , .jpg",
        tips2: "If the applicant does not receive the offer letter on or before the deadline, the applicant can submit the copy of the offer letter by email (ltq@edb.gov.hk), by post or in person to the Language Teacher Qualifications Team of the EDB, within two weeks after the application deadline.",
        tips3: "Provide details on your contribution relating to school education outside the school(s) in the past three years (at most one item per year) in a separate sheet as tabulated below, and upload the sheet here.",
        tabHeader: {
            schYear: "School Year",
            itemName: "Name of Items",
            itemDetails: "Details",
        },
        tips4: "(Assessment is based on the contribution made by the applicant and the role of the applicant in the respective items.)",
        tips5: "Provide details on your contribution to the school(s) in the past three years (at most three items per year) in a separate sheet as tabulated below, and upload the sheet here. This part must be read and signed by the Principal(s) of your serving school.",
        tips6: "Write a personal statement in either English or Chinese on the following. Use a separate sheet for each question and upload the sheets here.",
        tips7: {
            text1: "State the reasons for pursuing the master's degree programme specialising in the specified area of study; (maximum 300 words)",
            text2: "State the attributes that you possess as a good teacher, supported by examples of how these attributes are manifested; (maximum 400 words) and",
            text3: "Propose an action plan# to enhance the learning and teaching of your serving school. Explain how the pursuit of the master’s degree programme could facilitate the implementation of your proposed plan.(maximum 500 words)",
        },
        tips7Step: [{ step: "(i)" }, { step: "(ii)" }, { step: "(iii)" }],
        tips8: "# Please ensure that the Principal of your serving school has read and signed the action plan.",
        tips9: "(Content beyond the word limit will not be assessed. Punctuation marks are excluded in the word count.)",
    },

    label9: {
        tips1: "Send the following document by post or in person to the Language Teacher Qualifications Team, EDB (Office Address: Room 1107, Wu Chung House, 213 Queen's Road East, Wanchai, Hong Kong)",
        tips2: "Duly completed Recommendation Form with the signature of the Principal and School Chop",
        // tips2List: [
        //     { text: "Office Address:" },
        //     { text: "Language Teacher Qualifications Team" },
        //     { text: "Education Bureau" },
        //     { text: "Room 1107, Wu Chung House" },
        //     { text: "213 Queen's Road East" },
        //     { text: "Wanchai, Hong Kong" },
        // ],
        tips3: "The Recommendation Form is available on the EDB website <a href='https://www.edb.gov.hk/scholarship_teacher' target='_blank'>(https://www.edb.gov.hk/scholarship_teacher)</a>.",
        tips4: 'Mark "Application for the Scholarship for Teachers (Pursuit of Master’s Degree Programmes)" clearly on the envelope.',
        tips5: "(*The document should be returned by the Principal)",
        statement:
            "Arrangement will be made for the completion and submission of Recommendation Form to the Education Bureau by the deadline. ",
    },

    errorMsg: {
        // required: "This field is required",
        // requiredTrue: "Please enter the correct field",
        // IDNumber: "Please enter the correct id number",
        enName: "Please enter the correct English name",
        scName: "Please enter the correct Chinese name",
        email: "Please enter the correct email address",
        tel: {
            digit: "It needs to be 8-15 digits",
            rule: "need to match telephone number rule",
            faxRule: "need to match fax number rule",
        },
        date: {
            rule: "Please input a valid date",
            todayOrBefore: "Please select today or before",
            afterThisDate: "Please select a date after {{targetDate}}",
            age: "The applicant is at least 18 years old at the time of submission.",
            afterBirth: "This field needs to be after the date of birth",
        },
        tips: "Please enter the content in the correct format",
        upload: "Upload at least one file!",
        uploadMax: "Upload up to one file!",
        uploadMax5: "Upload up to five files!",
    },
};
export default Form027EN;
